import { createFileRoute } from "@tanstack/react-router"

import TabsLayout from "@/components/common/TabsLayout/TabsLayout"

const tabs = [
  {
    id: "price-change",
    label: "Price Change",
    path: `/app/pricing/price-change`,
  },
  {
    id: "price-change-history",
    label: "Selling Price History",
    path: `/app/pricing/history/price-change`,
  },
  {
    id: "purchase-cost-history",
    label: "Purchasing Cost History",
    path: `/app/pricing/history/purchase-cost`,
  },
]

export const Route = createFileRoute("/app/pricing/_layout")({
  component: () => <TabsLayout title='Pricing' tabs={tabs} />,
})
